import { Info } from "lucide-react"
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip"

interface KPICardProps {
  label: string
  icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>
  value: React.ReactNode
  subtext: string
  tooltip?: string
  valueColor?: string
}

export function KPICard({
  label,
  icon: Icon,
  value,
  subtext,
  tooltip,
  valueColor,
}: KPICardProps) {
  return (
    <div className="group bg-gradient-to-r from-white to-slate-50/50 border border-slate-200/60 rounded-xl p-4 flex flex-col shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5">
      <div className="flex items-start gap-3 h-full">
        <div className="w-8 h-8 bg-[#dbeafe] rounded-lg flex items-center justify-center shadow-sm">
          <Icon className="w-4 h-4" style={{ color: "#1e40af" }} />
        </div>
        <div className="flex-1 min-w-0 flex flex-col h-full">
          <div className="flex items-center gap-2">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wide group-hover:text-slate-600">
              {label}
            </span>
            {tooltip && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="w-3 h-3 text-slate-400 hover:text-slate-600 cursor-help transition-colors duration-200" />
                </TooltipTrigger>
                <TooltipContent side="top">{tooltip}</TooltipContent>
              </Tooltip>
            )}
          </div>
          <div
            className="text-lg font-bold leading-tight group-hover:text-slate-800 mt-1"
            style={{ color: valueColor || "#0f172a" }}
          >
            {value}
          </div>
          <div className="text-xs font-medium text-slate-500 group-hover:text-slate-600 mt-auto">
            {subtext}
          </div>
        </div>
      </div>
    </div>
  )
}
